class CurrencyIsoCodes {
    static Gbp: string = "GBP";
    static Usd: string = "USD"
}

export { CurrencyIsoCodes}
